/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2023-02-13 00:00:00
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Modal, TextContainer } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

type Props = {
  active: boolean,
  handleChangeModal: Function
};

type ComposedProps = Props & WithI18nProps;

class TermsConditionsModal extends Component<ComposedProps> {
  state = {
    isScrollToBottom: false
  };

  render() {
    const { isScrollToBottom } = this.state;
    const { i18n, active, content, onlyView = false } = this.props;

    return (
      <Modal
        open={active}
        limitHeight={true}
        onClose={() => this.handleChange()}
        title={i18n.translate('AdminHTML.SubscriptionV3.TermsConditions.title')}
        primaryAction={
          onlyView
            ? null
            : {
                disabled: !isScrollToBottom,
                content: i18n.translate(`AdminHTML.Common.Action.accept`),
                onAction: () => {
                  this.handleSubscribe();
                }
              }
        }
        secondaryActions={[
          {
            disabled: !isScrollToBottom,
            content: i18n.translate(`AdminHTML.Common.Action.${!onlyView ? 'decline' : 'close'}`),
            onAction: this.handleChange
          }
        ]}
        onScrolledToBottom={this.handleScroll}>
        <Modal.Section>
          <div onScroll={this.handleScroll} className="TermAndCondition">
            <TextContainer>
              <div
                dangerouslySetInnerHTML={{
                  __html: content
                }}></div>
            </TextContainer>
          </div>
        </Modal.Section>
      </Modal>
    );
  }

  handleChange = () => {
    this.props.handleChangeModal();
  };

  handleScroll = () => {
    this.setState({ isScrollToBottom: true });
  };

  handleSubscribe = () => {
    this.props.handleChangeModal();
    this.props.subscribe();
  };
}

export default withI18n()(TermsConditionsModal);
